import { render, staticRenderFns } from "./QADetail.vue?vue&type=template&id=427f0a6e&scoped=true"
import script from "./QADetail.vue?vue&type=script&lang=js"
export * from "./QADetail.vue?vue&type=script&lang=js"
import style0 from "./QADetail.vue?vue&type=style&index=0&id=427f0a6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427f0a6e",
  null
  
)

export default component.exports